import React from 'react';
import { Modal, Typography, Spin, Empty } from 'antd';
import { RegulationResponse } from '../../types/engagement.types';

const { Title, Text } = Typography;

interface RegulationModalProps {
  open: boolean;
  onClose: () => void;
  regulation: RegulationResponse | null;
  loading?: boolean;
}

export const RegulationModal: React.FC<RegulationModalProps> = ({
  open,
  onClose,
  regulation,
  loading,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      title={
        <Title level={4} style={{ margin: 0 }}>
          Regulamento do Sorteio
        </Title>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin size="large" />
        </div>
      ) : !regulation ? (
        <Empty description="Nenhum regulamento publicado" />
      ) : (
        <>
          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            Versão publicada em: {new Date(regulation.publishedAt).toLocaleString('pt-BR')}
          </Text>
          <div
            style={{
              whiteSpace: 'pre-wrap',
              fontFamily: 'inherit',
              lineHeight: 1.6,
              maxHeight: '60vh',
              overflowY: 'auto',
            }}
          >
            {regulation.content}
          </div>
        </>
      )}
    </Modal>
  );
};

export default RegulationModal;
